import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Form, Row, Col } from "react-bootstrap";
import "./ProviderDetails.scss"
import messages from "../../assets/i18n";
import { HeaderActions, FooterActions, ToastMessage } from '../../components'
import formatCnpj from '../../helpers/formatCnpj';
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import ItemList from '../../containers/ItemList/ItemList'
import SubcontractorToProviderModal from "../../components/SubcontractorToProviderModal/SubcontractorToProviderModal"

function ProviderDetails(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);

    const selectedProvider = useSelector(state => state.provider.selectedProvider);
    const isLoadingProviderUpdate = useSelector(state => state.provider.isLoadingProviderUpdate);
    const fetchedSubcontractorByProvider = useSelector(state => state.subcontractor.fetchedSubcontractorsByProvider.buscarSubcontratadoPorFornecedor);
    const isTableLoading                 = useSelector(state => state.subcontractor.fetchedSubcontractorsByProvider.loading);
    const reloadSubcontractorList        = useSelector(state => state.subcontractor.fetchedSubcontractorsByProvider.reloadSubcontractorList);
	    	    
	const pageMessages = messages[lang].providerDetailsPage
	const titlePage    = messages[lang].providerDetailsPage.title;

    const [showModal, setShowModal] = useState(false);

    const providerToast = useSelector(state => state.provider.providerToast);

    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');

	const pageBack = () => {
		props.history.push(`/provider-list`);
    };

    const changeDeclProdutor = (id, declaracaoProdutor) => {
        dispatch({
			type: 'UPDATE_DECLARACAO_PRODUTOR',
            payload: {
                fornecedorId: id,
                exigirDeclProdutor: declaracaoProdutor
            }
		})        
    }

    useEffect(() => {	
        setShowToast(providerToast.showToast)
        setMessageError(providerToast.message)
        setMessageType(providerToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [providerToast]);

    const changeSubcontractor = (id, isSubcontractor) => {
        dispatch({
			type: 'UPDATE_SUBCONTRACTOR_FLAG',
            payload: {
                fornecedorId: id,
                isSubcontratado: isSubcontractor
            }
		})        
    }

    const mappedSubcontractorList = () => {
        if (fetchedSubcontractorByProvider.length === 0) {
            return []
        }

        return fetchedSubcontractorByProvider.map((item) => {
            return [
                    item.id,
                    { 
                        text: item.cnpj ? formatCnpj(item.cnpj) : '',
                    },
                    { 
                        text: item.nomeFantasia,
                        maxLength: 4000
                    },
                    {
						text: <i className="icon-remove" />,
                        onClick: () => {
							dispatch({
                                type: 'REMOVE_PROVIDER_SUBCONTRACTOR',
                                payload: { fornecedorId: selectedProvider.data.id, subcontratadoId: item.id }
                            })
						},
					}
                ]
        });
    }

    const header = [
        pageMessages.codigo,
        pageMessages.cnpj,
        pageMessages.nome,
        ""
    ];
    
	useEffect(() => {
        dispatch({
            type: 'UNSET_SELECTED_PROVIDER',
            payload: {
                id: null,
                data: selectedProvider.data
            }
        })

        handleGetSubcontractorsList(selectedProvider.data.id);            
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        handleGetSubcontractorsList(selectedProvider.data.id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadSubcontractorList]);

    const handleGetSubcontractorsList = (fornecedorId) => {
        dispatch({
            type: 'GET_SUBCONTRACTORS_BY_PROVIDER',
            payload: {
                idFornecedor: fornecedorId
            }
        })

        dispatch({
            type: 'GET_SUBCONTRACTORS_NOT_LINKED_PROVIDER',
            payload: {
                fornecedorId: fornecedorId
            }
        })
    }

    const buttonGroupLeft = disabled => () => {
        return <>
        {
            <ButtonStandard 
			    id="open_subcontractor_modal_button"
			    text={pageMessages.adicionarSubcontratado}
                type="button"
			    textClass="text-2"
			    isLoading={isLoadingProviderUpdate}
                disabled={disabled}
			    className="btn btn-primary btn-save btn-light"
			    onClick={() => handleButtonAddProvider() }
		/>
        }
        </>
    };

    const handleButtonAddProvider = () => {
        setShowModal(true)
    }

	return (
		<div className="provider-details-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={titlePage}
			/>

            <SubcontractorToProviderModal
                show={showModal}
                onHide={() => { 
                    setShowModal(false) 
                    }} />

            <Container className="pt-3 justify-content-start">
                <Form className="px-3">
                    <Row>
                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.nome}</Form.Label>

                            <Form.Control
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={selectedProvider.data.nome}
                                disabled={true}
                                />

                        </Form.Group>

                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.cnpj}</Form.Label>
                            
                            <Form.Control
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={selectedProvider.data.cnpj ? formatCnpj(selectedProvider.data.cnpj) : ''}
                                disabled={true}
                                />
                        </Form.Group>	
                    </Row>	

                    <Row>
                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.cidade}</Form.Label>

                            <Form.Control
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={selectedProvider.data.cidade}
                                disabled={true}
                                />

                        </Form.Group>

                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.uf}</Form.Label>
                            
                            <Form.Control
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={selectedProvider.data.uf}
                                disabled={true}
                                />
                        </Form.Group>	
                    </Row>		

                    <Row>
                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.email}</Form.Label>

                            <Form.Control
                                className="text-2 border-radius-full"
                                type="text"
                                defaultValue={selectedProvider.data.email}
                                disabled={true}
                                />

                        </Form.Group>

                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.exigirDeclaracao}</Form.Label>

                            <div key={`inline-radio`} className="text-2">
                                <div key={selectedProvider.data}>
                                    <Form.Check
                                        inline
                                        label={messages[lang].yes}
                                        name="validCertificateRadio"
                                        type="radio"
                                        defaultChecked={selectedProvider.data.exigirDeclProdutor}
                                        id={`inline-radio-1`}
                                        onChange={() => changeDeclProdutor(selectedProvider.data.id, true)}
                                        disabled={isLoadingProviderUpdate}
                                    />
                                    <Form.Check
                                        inline
                                        label={messages[lang].no}
                                        name="validCertificateRadio"
                                        type="radio"
                                        defaultChecked={!selectedProvider.data.exigirDeclProdutor}
                                        id={`inline-radio-2`} 
                                        onChange={() => changeDeclProdutor(selectedProvider.data.id, false)}
                                        disabled={isLoadingProviderUpdate}
                                    />
                                </div>
                            </div>
                        </Form.Group>	

                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.subcontratado}</Form.Label>

                            <div key={`inline-radio`} className="text-2">
                                <div key={selectedProvider.data}>
                                    <Form.Check
                                        inline
                                        label={messages[lang].yes}
                                        name="subcontractorRadio"
                                        type="radio"
                                        defaultChecked={selectedProvider.data.isSubcontratado}
                                        id={`inline-radio-1`}
                                        onChange={() => changeSubcontractor(selectedProvider.data.id, true)}
                                        disabled={isLoadingProviderUpdate}
                                    />
                                    <Form.Check
                                        inline
                                        label={messages[lang].no}
                                        name="subcontractorRadio"
                                        type="radio"
                                        defaultChecked={!selectedProvider.data.isSubcontratado}
                                        id={`inline-radio-2`} 
                                        onChange={() => changeSubcontractor(selectedProvider.data.id, false)}
                                        disabled={isLoadingProviderUpdate}
                                    />
                                </div>
                            </div>
                        </Form.Group>
                    </Row>	
                    <Row className="mt-1">
                        <ItemList
                            header={header}
                            titleTable={'Subcontratados'}
                            isLoading={isTableLoading}
                            isEmpty={fetchedSubcontractorByProvider.length === 0}
                            listTable={mappedSubcontractorList()}
                        />
                    </Row>
                    <FooterActions
                        ButtonGroupLeft={buttonGroupLeft(isLoadingProviderUpdate)}
                    />			
                </Form>
            </Container>
		</div>
	)
}

export default withRouter(ProviderDetails);